import { render, staticRenderFns } from "./PageSupport.vue?vue&type=template&id=7c48f842&"
import script from "./PageSupport.vue?vue&type=script&lang=js&"
export * from "./PageSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports